module.exports = __webpack_public_path__ + "img/close.33dcb565.svg";